export enum SearchVehicle {
  BY_LICENSE_PLATE = 'BY_PLATE',
  BY_MAKE_MODEL = 'BY_MAKE_MODEL',
  BY_VIN = 'BY_VIN',
}
